import { useLocation } from "react-router-dom";

import AuthLayout from "components/layouts/AuthLayout";

import ForgotPasswordForm from "./ForgotPasswordForm";
import ResetPasswordForm from "./ResetPasswordForm";

const ForgotPasswordPage = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const token = query.get("token") ?? undefined;

  if (token) {
    return (
      <AuthLayout
        title="Reset password"
        subtitle="Choose a new password for your account."
        footerLink={{ label: "Back to login", to: "/login" }}
      >
        <ResetPasswordForm token={token} />
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Forgot password?"
      subtitle="No worries — enter your email and we'll send you a reset link."
      footerLink={{ label: "Back to login", to: "/login" }}
    >
      <ForgotPasswordForm />
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
